// 常用的固定数组

export const _ROLE = ['', '管理员', '普通用户', '固证工程师', '城市推广员', '固证服务站', '个人用户', '机构用户'];

// 订单状态
export const orderState = [
    {label: '', value: null},
    {label: '待支付', value: 0},
    {label: '已支付', value: 1},
    {label: '待领取', value: 2},
    {label: '办理中', value: 3},
    {label: '已完成', value: 4},
    {label: '已退款', value: 5},
    {label: '未出证', value: 6},
    {label: '已固证', value: 7},
    {label: '已公证', value: 8},

]


// 订单类型
export const orderType = [
    {label: '全部', value: ''},
    {label: '商业秘密', value: 1},
    {label: '图文作品', value: 2},
    {label: '影音作品', value: 3},

]

// 文件类型图表

export const fileTypeSrc = {
    'file': 'https://app.cgicp.org.cn/static/images/my/file.svg',
    'zip': 'https://app.cgicp.org.cn/static/images/my/zip.svg',
    'rar': 'https://app.cgicp.org.cn/static/images/my/zip.svg',
    'jpg': 'https://app.cgicp.org.cn/static/images/my/image.svg',
    'png': 'https://app.cgicp.org.cn/static/images/my/image.svg',
    'doc': 'https://app.cgicp.org.cn/static/images/my/word.svg',
    'docx': 'https://app.cgicp.org.cn/static/images/my/word.svg',
    'xlsx': 'https://app.cgicp.org.cn/static/images/my/excel.svg',
    'pdf': 'https://app.cgicp.org.cn/static/images/my/pdf.svg',
    'mp4': 'https://app.cgicp.org.cn/static/images/my/video.svg',
    'mp3': 'https://app.cgicp.org.cn/static/images/my/audio.svg',
    'm4a': 'https://app.cgicp.org.cn/static/images/my/audio.svg',
};

// 固证类型
export const gzTypeList = [
    {text: '商业秘密', value: '1', checked: true},
    {text: '图文作品', value: '2'},
    {text: '影音作品', value: '3'},
];
// 固证方式
export const gzFsList = [
    {text: '工程师固证', value: '1', checked: true},
    {text: '自己固证', value: null},
];

// 证据类型
export const orgList = [
    {text: '文字', value: '文字', checked: true},
    {text: '图片', value: '图片'},
    {text: '视频', value: '视频'},
    {text: '音频', value: '音频'}
];

// 文档类型
export const wdSuffix = ['doc','docx','dot','dtd','js','json','mpp','pdf','pot','pps','ppt','ppts','rtf','wdb','wps','xhtml','xlc','xlm','xls','xlt','xlw','xml','css','csv','htm','html','txt','xlsx'
];

// 图片
export const tpSuffix = ['dwg','dxf','gif','jp2','jpe','jpeg','jpg','png','svf','tif','tiff','bmp','webp','bmp','pcx','tif','tga','exif','fpx','svg','psd','cdr','ico'];

// 音频
export const ypSuffix = ['ac3','au','mp2','ogg','flac','ape','wav','mp3','aac','wma', 'm4a'];
// 视频
export const spSuffix = ['3gpp','mp4','mpeg','mpg','3gp','wmv','asf','asx','rm','rmvb','3gp','mov','m4v','avi','dat','mkv','flv','vob'];

// 其他
export const qtSuffix = ['rar','zip','arj','z','iso','jar','bz2','gz','tar','ace','lzh','cab','arj'];



export const swiperList =  [
    {
        id: 0,
        type: 'image',
        title: '',
        name: '',
        text: '',
        image: 'https://app.cgicp.org.cn/static/images/banner/banner1-1.png',
    }, {
        id: 1,
        type: 'image',
        title: '',
        name: '',
        text: '',
        image: 'https://app.cgicp.org.cn/static/images/banner/banner2.png',
    }, {
        id: 2,
        type: 'image',
        title: '',
        name: '',
        text: '',
        image: 'https://app.cgicp.org.cn/static/images/banner/banner3.png',
    }, {
        id: 3,
        type: 'image',
        title: '',
        name: '',
        text: '',
        image: 'https://app.cgicp.org.cn/static/images/banner/banner4.png',
    },];
export const  serverData =  [
    {
        title: '版权固证',
        value: '直接对接法院认可的公证处进行版权固证备案',
        image:  'https://app.cgicp.org.cn/static/images/home/icon1@2x.png',
        path: '/pages/apply/bqgz',
    },
    {
        title: '移动取证',
        value: '有效实现线上取证、线下取证、购买取证',
        image:  'https://app.cgicp.org.cn/static/images/home/icon2@2x.png',
        path: '/pages/apply/bqgz',
    },
    {
        title: '契约出证',
        value: '重要合同、借款、借货承诺、约定',
        image:  'https://app.cgicp.org.cn/static/images/home/icon3@2x.png',
        path: '/pages/apply/bqgz',
    },
    {
        title: '出具公证',
        value: '直接对接法院认可的公证处进行公证',
        image:  'https://app.cgicp.org.cn/static/images/home/icon4@2x.png',
        path: '/pages/apply/bqgz',
    }
];
export const  newsData =  [
    {

        value: '承担知识产权战略实施和知识产权强 省建设重点任务，及重大战略',
        time: '2022-11-17 15:35:20',
        image:  'https://app.cgicp.org.cn/static/images/home/new1.png',
    },  {

        value: '承担知识产权战略实施和知识产权强 省建设重点任务，及重大战略',
        time: '2022-11-17 15:35:20',
        image:  'https://app.cgicp.org.cn/static/images/home/new2.png',
    },  {

        value: '承担知识产权战略实施和知识产权强 省建设重点任务，及重大战略',
        time: '2022-11-17 15:35:20',
        image:  'https://app.cgicp.org.cn/static/images/home/new3.png',
    },

];
export const  planData = [
    {
        title: '知识产权',
        image:  'https://app.cgicp.org.cn/static/images/home/zscq@2x.png',

    },
    {
        title: '珠宝认证',
        image:  'https://app.cgicp.org.cn/static/images/home/zb@2x.png',
        path: '/pages/apply/fixedCertificate',
    },
    {
        title: '在线教育',
        image:  'https://app.cgicp.org.cn/static/images/home/jy@2x.png',
        path: '/pages/apply/fixedCertificate',
    },
    {
        title: '音乐行业',
        image:  'https://app.cgicp.org.cn/static/images/home/yy@2x.png',
        path: '/pages/apply/fixedCertificate'
    }
];
export const  tgyData =  [
    {
        title: '即时收益',
        value: '及时结算，T➕3现金到账更大的盈利空间',
        image:  'https://app.cgicp.org.cn/static/images/home/sy.png',
    },
    {
        title: '长久利益',
        value: '分享链接长久有效，一次邀请永久绑定',
        image:  'https://app.cgicp.org.cn/static/images/home/ly.png',
    },
    {
        title: '合作期限',
        value: '移动固证合伙人计划，一次合作，永久亲密合作',
        image:  'https://app.cgicp.org.cn/static/images/home/qx.png',
    },
    {
        title: '安全',
        value: '区块链技术功底，保障产品安全，信息安全',
        image:  'https://app.cgicp.org.cn/static/images/home/aq.png',
    }
];

export const swiperTgyList =  [
    {
        title: '便捷的推广方式',
        value: '您将获得分配的唯一ID，可通过朋友圈、微信、网站等各种方式让使用该ID的人成为您的推广用户',
        image:  'https://app.cgicp.org.cn/static/images/home/share.png',
    },
    {
        title: '轻松好赚钱',
        value: '成为代理商，享最低成本价，获高额利润差；超额完成任务，享受额外奖励',
        image:  'https://app.cgicp.org.cn/static/images/home/goods.png',
    }];

export const resumeList = [
    {
        id: 0,
        type: 'image',

        image: 'https://app.cgicp.org.cn/static/images/home/Pic1@2x.png',
    },
    {
        id: 1,
        type: 'image',

        image: 'https://app.cgicp.org.cn/static/images/home/PicC2@2x.png',
    },
    {
        id: 2,
        type: 'image',

        image: 'https://app.cgicp.org.cn/static/images/home/PicC3@2x.png',
    },
];



